import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

const PrivateRoute = () => {

  const { pathname } = useLocation()
  const { token, role } = useSelector(state => state.auth)
  const [, mode] = pathname.split('/')

  if (!token) return <Navigate to="/auth" replace />
  if (mode !== role) return <Navigate to={`/${role}`} replace />
  return <Outlet />
}

export default PrivateRoute
